<template>
  <component
    :class="['editorList', `editorList--${data.style}`]"
    :is="data.listStyle === 'unordered' ? 'ul' : 'ol'"
  >
    <li :key="index" v-for="(item, index) in data.items" v-html="item" />
  </component>
</template>

<script>
export default {
  name: 'EditorParagraph',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss">
.editorList {
  b,
  strong {
    font-weight: 700;
  }

  a {
    color: $cSec;
    transition: opacity $tr;

    &:hover {
      opacity: 0.6;
    }
  }

  &--unordered {
    li {
      position: relative;
      padding-left: 2rem;
      margin-bottom: 0.8rem;

      &::before {
        content: '\2022';
        color: $cAddDark;
        display: inline-block;
        font-size: 1.2rem;
        line-height: 2rem;
        position: absolute;
        left: 0;
        top: 2px;
      }
    }
  }

  &--ordered {
    list-style: decimal;
    list-style-position: inside;
    margin-bottom: 0.8rem;
  }

  li {
    font-size: 1.6rem;
    line-height: 2.6rem;
    color: $cAddDark02;

    a {
      color: $cSec;
      transition: opacity $tr;

      &:hover {
        opacity: 0.6;
      }
    }
  }
}
</style>
